import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { useAppColors } from '../../hooks/useAppColors';
import { useAuthStore } from '../../stores/authStore';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTranslation } from 'react-i18next';

export default function MembershipPausedBanner() {
  const { t } = useTranslation();
  const colors = useAppColors();
  const insets = useSafeAreaInsets();
  const hasPausedMembership = useAuthStore((s) => s.hasPausedMembership);
  const pausedMembership = useAuthStore((s) => s.pausedMembership);

  if (!hasPausedMembership || !pausedMembership) return null;

  const { membership } = pausedMembership;
  const activePause = membership.active_pause;

  const formatDate = (dateStr: string | null) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return date.toLocaleDateString();
  };

  return (
    <View
      style={[
        styles.banner,
        {
          backgroundColor: colors.warning + '20',
          borderBottomColor: colors.warning,
          // Topmost element on screen: keep clear of the OS status bar / notch
          paddingTop: 12 + insets.top,
        },
      ]}
    >
      <View style={styles.contentArea}>
        <Icon name="pause-circle-outline" size={20} color={colors.warning} />
        <View style={styles.textContainer}>
          <Text style={[styles.bannerText, { color: colors.text }]}>
            {t('pausedBanner.title', 'Membership Paused')}
          </Text>
          {activePause?.paused_end_date ? (
            <Text style={[styles.metaText, { color: colors.textSecondary }]}>
              {t('pausedBanner.until', 'Until {{date}}', {
                date: formatDate(activePause.paused_end_date),
              })}
            </Text>
          ) : (
            <Text style={[styles.metaText, { color: colors.textSecondary }]}>
              {t('pausedBanner.indefinite', 'Indefinite pause')}
            </Text>
          )}
          {activePause?.pause_reason && (
            <Text style={[styles.reasonText, { color: colors.textSecondary }]}>
              {t('pausedBanner.reason', 'Reason: {{reason}}', {
                reason: activePause.pause_reason,
              })}
            </Text>
          )}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    borderBottomWidth: 1,
    paddingHorizontal: 16,
    paddingVertical: 12,
  },
  contentArea: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  textContainer: {
    flex: 1,
  },
  bannerText: {
    fontSize: 14,
    fontWeight: '600',
  },
  metaText: {
    fontSize: 12,
    marginTop: 2,
  },
  reasonText: {
    fontSize: 12,
    marginTop: 2,
    fontStyle: 'italic',
  },
});
